import { EntityTypes } from '@rightship-tech/common-ui/models/basic.models';
import { DialogClientService } from '@rightship-tech/common-ui/services/basic/dialog-client.service';
import { UserClientService } from '@rightship-tech/common-ui/services/basic/user-client.service';
import { computedFrom } from 'aurelia-binding';
import { EventAggregator } from 'aurelia-event-aggregator';
import { useView } from "aurelia-framework";
import Enumerable from "linq";
import { RightshipQiMessages } from '../../../../../../configuration/rightshipqi-event-messages.constants';
import { RightShipDialogServiceConstants } from '../../../../../../constants/basics/rightship-dialog.constants';
import { CriteriaModel, GetCwSelfAssessmentReviewResponse } from "../../../../../../models/cwsa/cwsa.models";
import { CorrespondenceCountsResponse } from '../../../../../../models/vessels/vessel.models';
import { CwsaService } from "../../../../../../services/cwsa/cwsa.service";
import { CwsaAssignment } from '../../components/assignment/cwsa-assignment';

@useView('views/pages/modules/cwsa/tabs/review-criteria/cwsa-review-criteria.html')
export class CwsaReviewCriteria {

    private cwSelfAssessmentCriteriasRfiCounts: { [criteriaId: number]: number } = {};
    private reload: () => void;
    private correspondenceCounts: CorrespondenceCountsResponse;
    private _criterias: CriteriaModel[];
    public cwSelfAssessment: GetCwSelfAssessmentReviewResponse;
    public selectedCriteria: CriteriaModel;
    public selectedCategories: boolean[] = [];
    public keyword: string;
    public reviewCriteriaLoading: boolean;

    cwsaAssignment: CwsaAssignment;

    public additionalDetails: any;
    constructor(private cwsaService: CwsaService,
        private dialogClientService: DialogClientService,
        private userClientService: UserClientService,
        private eventAggregator: EventAggregator,
    ) { }

    activate(args: {
        cwSelfAssessment: GetCwSelfAssessmentReviewResponse,
        cwsaAssignment: CwsaAssignment,
        correspondenceCounts: CorrespondenceCountsResponse,
        reload: () => void
    }) {
        this.cwSelfAssessmentCriteriasRfiCounts = {};
        this.cwSelfAssessment = args.cwSelfAssessment;
        this.cwsaAssignment = args.cwsaAssignment;
        this.correspondenceCounts = args.correspondenceCounts;
        this.reload = args.reload;

        this.correspondenceCounts.countByLinkedEntities.forEach(item => {
            if (item.linkedEntityTypeId == EntityTypes.CrewWelfareCriteria) {
                if (!this.cwSelfAssessmentCriteriasRfiCounts[item.linkedEntityId]) {
                    this.cwSelfAssessmentCriteriasRfiCounts[item.linkedEntityId] = 0;
                }
                this.cwSelfAssessmentCriteriasRfiCounts[item.linkedEntityId] += 1;
            }
        });
    }

    async attached() {
        this.reviewCriteriaLoading = true;
        const response = await this.cwsaService.getReviewCriteria(this.cwSelfAssessment.cwSelfAssessmentGuid).finally(() => {
            this.reviewCriteriaLoading = false;
        });
        this._criterias = response.criterias;

        if (this._criterias && this._criterias.length > 0) {
            this.selectedCriteria = this.passedCriterias && this.passedCriterias.length > 0 ? this.passedCriterias[0] : this.failedCriterias[0];
        }
    }

    goToCorrespondenceTab(criteriaId: number) {
        this.eventAggregator.publish(RightshipQiMessages.viewCorrespondenceTab, {
            initialSubtaskLinkedEntityId: criteriaId,
            initialSubtaskLinkedEntityTypeId: EntityTypes.CrewWelfareCriteria
        });
    }

    toggle(element: HTMLElement, arrow: HTMLElement) {
        if (element) {
            $(element).slideToggle()
            if ($(arrow).hasClass('is-opened')) {
                $(arrow).removeClass('is-opened');
            } else {
                $(arrow).addClass('is-opened');
            }
        }
    }

    filter(passed: boolean) {
        if (this.selectedCategories.indexOf(passed) < 0) {
            this.selectedCategories.push(passed);
        } else {
            this.selectedCategories = this.selectedCategories.filter(x => x !== passed);
        }
    }

    viewTask(criteria: CriteriaModel) {
        this.selectedCriteria = criteria;
        this.additionalDetails = this.selectedCriteria.additionalDetails ? JSON.parse(this.selectedCriteria.additionalDetails) : null;
    }

    getCriterias() {
        let result = Enumerable.from(this._criterias).toArray();

        if (this.keyword) {
            result = Enumerable.from(result).where(x => x.name.toLowerCase().includes(this.keyword.toLowerCase())).toArray();
        }

        if (this.selectedCategories && this.selectedCategories.length > 0) {
            result = result.filter(x => this.selectedCategories.indexOf(x.passed ? true : false) >= 0);
        }

        return result;
    }

    @computedFrom('selectedCategories', 'selectedCategories.length')
    public get passedSelected() {
        return this.selectedCategories.indexOf(true) >= 0;
    }

    @computedFrom('selectedCategories', 'selectedCategories.length')
    public get failedSelected() {
        return this.selectedCategories.indexOf(false) >= 0;
    }

    @computedFrom('_criterias', 'keyword')
    public get passedCount() {
        return this.passedCriterias.length;
    }

    @computedFrom('_criterias', 'keyword')
    public get failedCount() {
        return this.failedCriterias.length;
    }

    @computedFrom('_criterias', 'keyword', 'selectedCategories', 'selectedCategories.length')
    public get passedCriterias() {
        const result = this.getCriterias().filter(x => x.passed);
        return result;
    }

    @computedFrom('_criterias', 'keyword', 'selectedCategories', 'selectedCategories.length')
    public get failedCriterias() {
        const result = this.getCriterias().filter(x => !x.passed);
        return result;
    }

    @computedFrom('selectedCriteria', 'selectedCriteria.code')
    public get reviewRule() {
        return this.selectedCriteria ? this.selectedCriteria.code : '';
    }

    openAddRfiDialog(cwSelfAssessmentReviewRuleId: number) {

        if (this.cwsaAssignment.assignedEntity.assignedTo != this.userClientService.currentUser.user.id) {
            this.dialogClientService.show(RightShipDialogServiceConstants.URLs.CwsaAssignmentDialog, {
                name: "Cwsa assessment",
                submit: this.cwsaAssignment.assignToMe,
                callback: this.openAddRfiDialog.bind(this, cwSelfAssessmentReviewRuleId),
                currentAssignment: null
            }, true, false, false);
        }
        else {
            this.dialogClientService.show(RightShipDialogServiceConstants.URLs.AddSubtaskDialog, {
                entityId: this.cwSelfAssessment.cwSelfAssessmentId,
                entityTypeId: EntityTypes.CrewWelfare,
                emails: [],
                linkedEntityId: cwSelfAssessmentReviewRuleId,
                linkedEntityTypeId: EntityTypes.CrewWelfareCriteria,
                isWet: false,
                liaseWithShipManagers: [],
                isPartialRFI: false,
                subtaskTypes: [],
                skipInvitation: true,
                subtaskCorrespondenceId: null,
                reload: this.reload
            }, true, false, false, 'right');
        }
    }
}